import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Self-heal the "blank screen on reload" case after a production redeploy.
// When a cached index.html references a JS/CSS chunk hash that no longer
// exists on the server, the script 404s and React never mounts — the page
// goes blank with no React error to catch. We listen for those resource
// load failures (and chunk-load promise rejections) and force a one-time
// cache-busting reload so the browser fetches the fresh bundle.
(function installStaleBundleGuard() {
  const KEY = "vts:stale-reload";
  const reloadOnce = () => {
    try {
      if (!sessionStorage.getItem(KEY)) {
        sessionStorage.setItem(KEY, String(Date.now()));
        window.location.reload();
      }
    } catch {
      /* sessionStorage blocked — give up silently */
    }
  };

  // A successful mount means the bundle loaded fine; clear the guard so a
  // genuine future redeploy can reload again.
  window.addEventListener("load", () => {
    try {
      sessionStorage.removeItem(KEY);
    } catch {
      /* ignore */
    }
  });

  // <script>/<link> 404s surface as capture-phase error events on window.
  window.addEventListener(
    "error",
    (e) => {
      const t = e?.target;
      const isResource =
        t && (t.tagName === "SCRIPT" || t.tagName === "LINK");
      const src = (t && (t.src || t.href)) || "";
      if (isResource && /\/static\//.test(src)) reloadOnce();
    },
    true,
  );

  // Dynamic import() failures bubble as unhandled rejections.
  window.addEventListener("unhandledrejection", (e) => {
    const msg = String(e?.reason?.message || e?.reason || "");
    if (
      /ChunkLoadError/i.test(msg) ||
      /Loading chunk [\d]+ failed/i.test(msg) ||
      /Loading CSS chunk/i.test(msg) ||
      /dynamically imported module/i.test(msg)
    ) {
      reloadOnce();
    }
  });
})();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
